var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isPopupOpen)?_c('div',{staticClass:"layer-popup-view"},[_c(_setup.layerPopup,{tag:"component",attrs:{"payloads":_setup.payloads},on:{"on-close":_setup.onClickClose}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }